
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/OrganizationTree/OrganizationTree.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./OrganizationTree.html');
        
        var script = require('./OrganizationTree.ts').default;
        module.exports = require('./OrganizationTree.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    